import PageHero from "../components/sections/PageHero";
import GoldButton from "../components/ui/GoldButton";
import SectionLabel from "../components/ui/SectionLabel";

const Uk = () => (
  <>
    <PageHero
      label="UK"
      title="Reliable software,"
      titleAccent="at honest prices."
      subtitle="UK businesses served with full-stack technology and AI. UK timezone. Fluent English communication."
    />

    <section style={{ background: "#050505", padding: "0 0 120px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 24,
            marginBottom: 48,
          }}
        >
          <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="GDPR" />
            <p style={{ marginTop: 18, fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#F8F4EC", lineHeight: 1.8 }}>
              GDPR-compliant architecture standard · Cookie consent, data subject rights · UK data residency (AWS London eu-west-2)
            </p>
          </div>
          <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="COMMUNITY" />
            <p style={{ marginTop: 18, fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#F8F4EC", lineHeight: 1.8 }}>
              1.5M+ British Indians in pharmacy, restaurants, property, accountancy, import/export, and care homes.
            </p>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <GoldButton href="/contact">START A UK PROJECT</GoldButton>
        </div>
      </div>
    </section>
  </>
);

export default Uk;
